/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dispatch, FormEvent, SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import VerifyInput from "react-verification-input";

import Button from "@/components/buttons/Button";
import { ProfileTabs } from "@/components/gate/profiles/types";
import { IconBack } from "@/components/icons/main.icons";

import { ROUTES } from "@/config/routes";
import { useJwtCreate } from "@/hooks/api/login.hooks";
import { useCheckPinCode } from "@/hooks/api/user.hooks";
import { cn } from "@/utils/cn";
import { onError } from "@/utils/onError";

const CodeForProfile = ({
  profileId,
  setTab,
  isEdit,
}: {
  profileId: string;
  setTab: Dispatch<SetStateAction<ProfileTabs>>;
  isEdit: boolean;
}) => {
  const { t } = useTranslation();
  const [error, setError] = useState<string | null>(null);
  const [code, setCode] = useState<string>("");
  const navigate = useNavigate();
  const { mutate: checkCode, isPending: isCheckPending } = useCheckPinCode();
  const { mutate, isPending: isJwtPending } = useJwtCreate({
    profileId,
    age: "18",
  });

  const isPending = isCheckPending || isJwtPending;

  const onBack = () => {
    setTab(ProfileTabs.PROFILES);
  };

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    console.log("code", code);
    const formData = new FormData();
    formData.append("pin_code", code);
    formData.append("profile_id", profileId);
    checkCode(
      { formData },
      {
        onSuccess: () => {
          mutate(
            { profile_id: profileId, pin_code: code },
            {
              onSuccess: () => {
                if (isEdit) {
                  navigate(ROUTES.GATE.UPDATE_PROFILE.replace(":id", profileId.toString()));
                } else {
                  navigate(ROUTES.MAIN.MAIN);
                }
              },
              onError: (err: any) => {
                console.log("error", err);
                if (err.response.data.pin_code) {
                  setError(err.response.data.pin_code);
                }
              },
            },
          );
        },
        onError,
      },
    );
  };
  return (
    <div className="mt-10 flex h-full min-h-screen w-full flex-col justify-between gap-[110px]">
      <button className="flex w-fit items-center gap-2 rounded-full bg-surface-bright px-8 py-[18px]" onClick={onBack}>
        <IconBack className="size-5 stroke-white" />
        {t("Actions.back")}
      </button>
      <div className="text-center">
        <h2 className="mb-4 text-[36px]/[44px] font-semibold">{t("Profile.enter-pin-code")}</h2>
        <p className="">{t("Profile.enter-pin-code-desc")}</p>
        <form onSubmit={handleSubmit} className={"mt-6 flex flex-col items-center"}>
          <VerifyInput
            placeholder={" "}
            value={code}
            onChange={setCode}
            validChars={"0-9"}
            length={4}
            classNames={{
              container: cn(
                "h-20 w-[16.875rem] flex gap-[0.625rem] max-lg:gap-[0.313rem] max-sm:h-[4.375rem] max-md:w-[14rem]",
              ),
              character: cn(
                "bg-surface-bright rounded-full flex items-center justify-center text-on-primary outline-transparent -outline-offset-1 outline-1 outline border-none transition-outline",
                error && "outline-red-1",
              ),
              characterSelected: "pin-input bg-surface-container-high border-none transition-all outline-on-primary",
              characterFilled: "bg-surface-container-high",
            }}
          />
          <div className={"mt-6 space-y-3"}>
            <Button
              type={"submit"}
              size={"medium"}
              aria-label={t("Actions.confirm")}
              className={"w-full max-w-[400px]"}
              isLoading={isPending}
            >
              {t("Actions.confirm")}
            </Button>
            <Button
              size={"medium"}
              aria-label={t("Actions.cancel")}
              onClick={onBack}
              color={"black"}
              className={"w-[400px] max-md:w-full"}
            >
              {t("Actions.cancel")}
            </Button>
          </div>
        </form>
      </div>
      <div className="h-20"></div>
    </div>
  );
};

export default CodeForProfile;
